import React from "react";
import Link from "gatsby-link";

import "./TopNavigation.css";

export default class TopNavigation extends React.Component
{
    render () {
        return (
            <nav>
                <ul>
                    <li>
                        <Link to="/">Startseite</Link>
                    </li>

                    <li>
                        <Link to="/schleiferei/">Messer- und Scherenschleiferei</Link>
                    </li>

                    <li className="is-hidden-sm">
                        <Link to="/kontakt/">Kontakt</Link>
                    </li>
                </ul>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/TopNavigation.jsx